export class CurrentInfoHolder 
{
        public Name = '';
        public Phone = '';
        public Icon = 'assets/img/placeholder.png';
        public Open = true;
        public NotOpenMessage = 'No momento não estamos atendendo.';
        public CentralCanChangeWaitTime = true;
        public UseDinamicWaitTime = false;
        public HasStripe = false;
        public PixelID = '';

        //Authorization
        public CentralRequireAuthorization = false;
        public AgentRequireAuthorization = false;

        public Table = false;
        public TableWaitTime = 6000000000;

        public Balcony = false;
        public BalconyWaitTime = 6000000000;

        public Delivery = false;
        public DeliveryWaitTime = 6000000000;
        public PlaceID = '';
        public MaximumDistance = 0;
        public PlaceLatitude = 0;
        public PlaceLongitude = 0;

        public ChargeDeliveryFee = false;
        public DeliveryFee = 0;

        public ChargeByValue = false;
        public ValueThreshold = 0;
        public ByValueFee = 0;

        public ChargeByDistance = false;
        public InitialFee = 0;
        public FeeByDistanceUnit = 0;
        public InitialDistance = 0;
 
        public ChargeByRegion = false;
        public DeliveryRegions = new Array<DeliveryRegion>();

        public OrderFloor = false;
        public FloorValue = 0;

        public WillComeHere = false;
        public WillComeHereWaitTime = 6000000000;

        public Drive = false;
        public DriveWaitTime = 6000000000;

        public GlobalDiscountFactor = 0;
        public AgentDiscountFactor = 0;
        public CustomerDiscountFactor = 0;

        public HasWarning = false;
        public WarningMessage = ""

        public TagWaitTime = new Array<TagWaitTime>();
    }

    export class DeliveryRegion
    {
        public ID = '';
        public StartDistance = 0;
        public EndDistance = 0;
        public Fee = 0;
    }

    export class TagWaitTime
    {
        public ID = '';
        public Tag = '';
        public WaitTime = 0;
    }
